export default "__VITE_PUBLIC_ASSET__29543b08__"